export default "__VITE_ASSET__BXBm3VIV__"